import { Routes } from '@angular/router';

import { AppComponent } from './app.component';
import { AuthGuard } from './features/auth/auth.guard';
export const APP_ROUTES: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full',
      },
      {
        path: 'app',
        loadChildren: () => import('@app/modules/pages/pages-routing').then((m) => m.APP_ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'login',
        loadChildren: () => import('@app/modules/login/login-routing').then((m) => m.LOGIN_ROUTING),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
